class CustomProductPage {
  constructor() {
    this.mainContainer = document.querySelector(".product-switchers-container");

    this.switcher = this.mainContainer?.querySelector(".variants-container .switcher-content");
    this.variants = this.switcher?.querySelectorAll(".switcher-label");

    this.variantLabel = this.getInitialVariantLabel();
    this.variantInput = this.variantLabel?.querySelector("input[type='radio']");
    this.variantId = this.variantInput?.getAttribute("value");
    this.variantPrice = this.variantInput?.getAttribute("data-price");
    this.variantColor = this.variantLabel?.querySelector(".color-value");
    this.variantTitle = this.variantLabel?.querySelector(".title-value");
    this.variantSku = document.getElementById("sku-value");

    this.productForm = this.mainContainer?.querySelector("form");

    this.submitBtn = document.getElementById("custom-add-to-cart-btn");
    this.oosBtn = document.getElementById("custom-oos-btn");
    this.klaviyoBtn = document.getElementById("klaviyo-bis-button-container");

    this.priceSpan = this.submitBtn?.querySelector(".price-value");

    this.initEvents();
  }
  getInitialVariantLabel() {
    if (!this.variants?.length) return null;

    const checked = [...this.variants].find((el) => el.querySelector("input[type='radio']:checked"));
    if (checked) return checked;

    const available = [...this.variants].find((el) => !el.classList.contains("disabled"));
    return available || this.variants[0];
  }
  initEvents() {
    this.productForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.addToCartInsteadFormSubmit(this.variantId);
    });
    this.variants?.forEach((el) => {
      el.querySelector("input[type='radio']")?.addEventListener("change", () => { this.changeVariant(el); });
    });
  }

  updatePrice() {
    if (this.priceSpan) {
      this.priceSpan.textContent = this.variantPrice;
    }
  }
  verifStock() {
    this.klaviyoBtn = document.getElementById("klaviyo-bis-button-container");

    if (this.variantLabel?.classList.contains("disabled")) {
      this.submitBtn?.setAttribute("disabled", "true");
      if (this.klaviyoBtn) {
        this.klaviyoBtn.classList.add("visible");
      }
      this.oosBtn?.removeAttribute("disabled");
    } else {
      if (this.klaviyoBtn) {
        this.klaviyoBtn.classList.remove("visible");
      }
      this.oosBtn?.setAttribute("disabled", "true");
      this.submitBtn?.removeAttribute("disabled");
    }
  }
  selectAssociatedMedia() {
    var mediaUrl = this.variantInput?.getAttribute("data-media-url");
    var media = mediaUrl ? document.querySelector(`.image-gallery-container img[src*="${mediaUrl}"]`) : null;

    if (media) {
      media.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
  changeVariant(element) {
    this.variantLabel = element;
    this.variantInput = element.querySelector("input[type='radio']");
    this.variantId = this.variantInput?.getAttribute("value");
    this.variantPrice = this.variantInput?.getAttribute("data-price");
    this.variantColor = this.variantLabel?.querySelector(".color-value");
    this.variantTitle = this.variantLabel?.querySelector(".title-value");

    if (this.variantSku) {
      this.variantSku.innerHTML = this.variantInput?.getAttribute("data-sku");
    }

    this.selectAssociatedMedia();
    this.verifStock();
    this.updatePrice();
  }

  addToCartInsteadFormSubmit(variantId) {
    var my_properties = {};

    my_properties.Color = this.variantColor.textContent;
    my_properties.Title = this.variantTitle.textContent;
    customAddToCart(variantId, 1, my_properties);
  }
}

window.addEventListener("load", function() {
  const productPage = new CustomProductPage();
});